import api from '../api'

const getRooms = (context, currentUnityId) => {
  context.commit('setLoadingRooms', true)

  const selectedRooms = JSON.parse(localStorage.getItem('selectedRooms'))
  const filteredRooms = selectedRooms?.filter(
    room => room.company_id === currentUnityId
  )
  context.commit('setRooms', filteredRooms?.length ? filteredRooms : [])

  api
    .getAllClinicRooms(currentUnityId)
    .then(({ data }) => {
      context.commit('setRooms', data)
    })
    .finally(() => context.commit('setLoadingRooms', false))
}

function setSelectedRooms(context, payload) {
  context.commit('setSelectedRooms', payload)
}

export default {
  getRooms,
  setSelectedRooms
}
